import { graphql, useStaticQuery } from 'gatsby';

const useCommercialToolboxContentHub = () => {
  const commercialToolboxContentHub = useStaticQuery(graphql`
    {
      allArticle: allContentfulBlog(
        sort: { publishDate: DESC }
        filter: {
          tags: { nin: "Covid19" }
          seo: {
            pageUrl: { regex: "/^(?!success-story.*$).*/g" }
            taxonomy: { businessFocus: { in: "Commercial" } }
          }
        }
        limit: 10
      ) {
        nodes {
          ...BlogCardFeatured
        }
      }
      allContentfulWebinar(
        filter: {
          onDemandPage: { eq: true }
          removeFromSplashPage: { eq: false }
          seo: { taxonomy: { businessFocus: { in: "Commercial" } } }
        }
        limit: 10
        sort: { createdAt: DESC }
      ) {
        nodes {
          ...WebinarCardFeatured
        }
      }
      allContentfulPodcast(
        filter: { seo: { taxonomy: { businessFocus: { in: "Commercial" } } } }
        limit: 10
        sort: { podcastDate: DESC }
      ) {
        nodes {
          ...PodcastCard
        }
      }
      allTemplates: allContentfulDownloadableContent(
        filter: { seo: { taxonomy: { businessFocus: { in: "Commercial" } } } }
        limit: 10
        sort: { id: DESC }
      ) {
        nodes {
          ...DownloadableContentCard
        }
      }
    }
  `);
  return commercialToolboxContentHub;
};

export default useCommercialToolboxContentHub;
